// TESTE_RAPIDO_2810 (GROK2): "Novo teste" compacto — nome/WhatsApp opcionais, Sem/Com adulto, telas 1-4,
// grade de apps, resumo e 1 botão Gerar; resultado no mesmo painel. Usa /api/xui/quick-test/*.
// O TesteRapidoModal antigo continua no código. Switch: private/TESTE_RAPIDO_2810_OFF.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Copy, Loader2, MessageCircle } from 'lucide-react';
import { API_BASE_URL } from '../apiBase';
import { formatApiError } from '../context/AuthContext';
import { planHasContentChoice } from '../lib/planContentProfile';
import { sendAccessWhatsApp } from '../lib/sendAccessWhatsApp';
import ClienteRapido2810 from './ClienteRapido2810'; // CRIAR_RAPIDO_2810
import { fetchAuraxFlags } from '../lib/auraxFlags';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { cn } from '../lib/utils';
import AppLogo2810 from './AppLogo2810'; // APP_LOGO_2810
import { titleCase2810 } from '../lib/displayCase2810'; // CASE_2810
import { painelTesteBody0311 } from './PainelFiltro0311'; // EQUIPE_V2_0311

function rid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export default function NovoTesteCompacto({ open, onOpenChange, initialMode = 'teste' }) {
  // CRIAR_RAPIDO_2810: alternar Teste | Cliente
  const [flags2810, setFlags2810] = useState({});
  const [mode, setMode] = useState(initialMode);
  useEffect(() => { fetchAuraxFlags().then((f) => setFlags2810(f || {})).catch(() => {}); }, []);
  useEffect(() => { if (open) setMode(initialMode); }, [open, initialMode]);
  const cliente2810 = !!flags2810.criar_rapido_2810 && mode === 'cliente';
  const [apps, setApps] = useState(null);
  const [err, setErr] = useState('');
  const [nome, setNome] = useState('');
  const [whats, setWhats] = useState('');
  const [adult, setAdult] = useState(false);
  const [telas, setTelas] = useState(1);
  const [appId, setAppId] = useState('');
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) return;
    setRes(null); setNome(''); setWhats(''); setAdult(false); setTelas(1); setAppId(''); setCopied(false);
    axios.get(`${API_BASE_URL}/api/xui/quick-test/apps`, { withCredentials: true, timeout: 30000 })
      .then(({ data }) => { setApps(data.apps || []); setErr((data.missing || []).filter((m) => !/logo/.test(m)).join(' ')); })
      .catch((e) => setErr(formatApiError(e?.response?.data?.detail) || 'Não foi possível carregar os aplicativos.'));
  }, [open]);

  const app = (apps || []).find((a) => a.id === appId);
  const plan = app?.plan || (apps || [])[0]?.plan;
  const choice = planHasContentChoice(plan);
  const minT = appId === '__web_player__' ? 2 : 1;

  const gerar = async () => {
    if (busy || !app?.ready) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API_BASE_URL}/api/xui/quick-test/one-click`, {
        partner_app_id: app.id, plan_id: app.plan?.id || '', app_name: app.name, request_id: rid(),
        rapido_2810: true, nome: nome.trim(), whatsapp: whats.replace(/\D/g, ''),
        content_mode: choice ? (adult ? 'adult' : 'family') : '', telas: Math.max(telas, minT), ...painelTesteBody0311(),
      }, { withCredentials: true, timeout: 120000 });
      setRes(data);
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || 'Não foi possível gerar o teste.');
    } finally { setBusy(false); }
  };

  const msg = res ? (String(res.template_msg || '').trim()
    || `Usuário: ${res.username || ''}\nSenha: ${res.password || ''}\nVencimento: ${res.exp_date_formatted || ''}`) : '';
  const seg = (on) => cn('h-10 flex-1 rounded-lg border text-sm font-semibold', on ? 'border-primary bg-primary text-primary-foreground' : 'bg-background hover:bg-muted');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] w-[calc(100vw-1.5rem)] max-w-lg overflow-y-auto p-4" data-novo-teste-2810>
        <div className="flex items-center justify-between gap-2 pr-10"><h2 className="text-lg font-semibold">{cliente2810 ? 'Novo cliente' : 'Novo teste'}</h2>
          {flags2810.criar_rapido_2810 ? (
            <div className="flex rounded-lg border p-0.5 text-sm" data-toggle-2810>
              {[['teste', 'Teste'], ['cliente', 'Cliente']].map(([k, l]) => (
                <button key={k} type="button" onClick={() => setMode(k)} className={cn('rounded-md px-3 py-1 font-semibold', mode === k ? 'bg-primary text-primary-foreground' : 'text-muted-foreground')}>{l}</button>))}
            </div>) : null}</div>
        {cliente2810 ? <ClienteRapido2810 apps={apps} flags={flags2810} /> : res ? (
          <div className="space-y-3">
            <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-3 text-sm">
              <div>✅ Teste gerado · <b>{res.username}</b></div>
              <div>Senha: <b>{res.password}</b>{res.exp_date_formatted ? <> · vence {res.exp_date_formatted}</> : null}</div>
            </div>
            <pre className="max-h-56 overflow-auto whitespace-pre-wrap rounded-lg border bg-muted/40 p-2 text-xs">{msg}</pre>
            <div className="flex flex-wrap gap-2">
              <Button className="flex-1 gap-1" onClick={() => { navigator.clipboard?.writeText(msg); setCopied(true); }}>
                {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}{copied ? 'Copiado' : 'Copiar mensagem'}</Button>
              {whats.replace(/\D/g, '').length >= 10 ? (
                <Button variant="outline" className="flex-1 gap-1" onClick={async () => {
                  const r = await sendAccessWhatsApp({ phone: whats, name: nome || res.username, message: msg });
                  if (r?.ok) toast.success('Enviado no WhatsApp.'); else toast.error(r?.error || 'Não foi possível enviar.');
                }}><MessageCircle className="h-4 w-4" />Enviar WhatsApp</Button>
              ) : null}
            </div>
            <Button variant="ghost" className="w-full" onClick={() => { setRes(null); setAppId(''); }}>Gerar outro</Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-2">
              <Input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome (opcional)" className="h-10" />
              <Input value={whats} onChange={(e) => setWhats(e.target.value)} placeholder="WhatsApp (opcional)" inputMode="tel" className="h-10" />
            </div>
            <div>
              <div className="flex gap-2">
                <button type="button" className={seg(!adult)} onClick={() => setAdult(false)}>Sem adulto</button>
                <button type="button" className={seg(adult)} onClick={() => setAdult(true)} disabled={!choice}>Com adulto</button>
              </div>
              {!choice && plan ? <p className="mt-1 text-xs text-muted-foreground">O plano de teste não tem opção de conteúdo; vai o padrão do plano.</p> : null}
            </div>
            <div className="flex items-center gap-2">
              <span className="w-12 text-sm font-medium">Telas</span>
              {[1, 2, 3, 4].map((n) => (
                <button key={n} type="button" disabled={n < minT} onClick={() => setTelas(n)} className={cn(seg(Math.max(telas, minT) === n), 'h-9 disabled:opacity-40')}>{n}</button>
              ))}
            </div>
            {apps === null ? <div className="flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" />Carregando apps…</div> : (
              <div className="grid grid-cols-4 gap-1.5 sm:grid-cols-5" data-app-logo2-2810>
                {apps.map((a) => (
                  <button key={a.id} type="button" disabled={!a.ready} onClick={() => setAppId(a.id)} title={titleCase2810(a.name)}
                    className={cn('group flex min-w-0 flex-col items-center gap-1 rounded-xl border bg-card px-1 py-1.5 text-center shadow-sm transition hover:shadow-md', appId === a.id ? 'border-primary bg-primary/10 ring-2 ring-primary' : 'hover:bg-muted', !a.ready && 'opacity-40')}>
                    <AppLogo2810 app={a} className="h-9 w-9 rounded-lg" textClass="text-[11px]" />
                    <span className="line-clamp-2 w-full break-words text-[10px] font-semibold leading-tight">{titleCase2810(a.name || a.label || a.app_name)}</span>
                  </button>
                ))}
              </div>
            )}
            {err ? <p className="text-xs text-destructive">{err}</p> : null}
            <div className="rounded-lg bg-muted/50 p-2 text-sm">
              {app ? <>Teste <b>{titleCase2810(app.name)}</b> · {Math.max(telas, minT)} tela(s) · {choice ? (adult ? 'com adulto' : 'sem adulto') : 'conteúdo padrão'}{nome.trim() ? <> · {nome.trim()}</> : null}</> : 'Escolha o aplicativo.'}
            </div>
            <Button onClick={gerar} disabled={!app?.ready || busy} className="h-12 w-full text-base font-semibold">
              {busy ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Gerando…</> : 'Gerar teste'}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
